<template>
  <div>
    <div style="margin:20px 0"><!-- STI个人目标 -->{{ $t("STI_Self") }}</div>
    <STIComponent ref="STIComponent" :tabName="'STICom'"></STIComponent>
    <Collapse v-model="value" simple style="border:0;margin-top:50px">
      <Panel
        name="2"
        hide-arrow
        style="margin-bottom: 20px;border:0"
        v-show="userInfoa.id"
      >
        <FormTitle
          :titleText="$t('Approval_History') + '/' + $t('Action_History')"
        /><!-- 审批历史/操作履历 -->
        <div style="margin-top: 30px" slot="content">
          <Tabs type="card" v-model="panel4value" name="sub-tabs">
            <TabPane
              :label="$t('Approval_History')"
              name="审批历史"
              tab="sub-tabs"
              :index="1"
              ><!-- 审批历史 -->
              <ApprovalHistory
                ref="ApprovalHistory"
                @pageChangeApproval="pageChangeApproval"
              ></ApprovalHistory>
            </TabPane>
            <TabPane
              :label="$t('Action_History')"
              name="操作履历"
              tab="sub-tabs"
              :index="2"
              ><!-- 操作履历 -->
              <OperationHistory
                ref="OperationHistory"
                @pageChangeOperation="pageChangeOperation"
              ></OperationHistory>
            </TabPane>
          </Tabs>
        </div>
      </Panel>
    </Collapse>
    <div class="btnRight" style="padding-top:60px" v-if="cardHid">
      <Button
        type="primary"
        class="btn"
        v-if="
          (status == '7' || status == '92' || status == '94') &&
            userDeptFlag == '1'
        "
        @click="submit"
        >{{ $t("Submit")
        }}<!-- 提交 --></Button
      >
      <Button
        type="primary"
        class="btn"
        v-if="beApprovalFlag == '2'"
        @click="(approvalFlag = 1), approvalSave()"
        >{{ $t("Approves") }}</Button
      >
      <Button
        type="primary"
        class="btn"
        v-if="beApprovalFlag == '2' && userDeptFlag != '1'"
        @click="(approvalFlag = 2), approvalSave()"
        >{{ $t("Reject") }}</Button
      >
      <Button
        type="primary"
        class="btn"
        v-if="stiRevokeFlag == '1'"
        @click="cxSti"
        >撤销</Button
      >
      <!-- <Button type="primary" class="btn" v-if="!isHistory"  @click="QAClick">{{$t('Q&A')}}</Button> -->
      <Button type="primary" class="btn" v-if="isHistory" @click="returnApply"
        >{{ $t("Return")
        }}<!-- 返回 --></Button
      >
      <!-- <Button type="primary" class="btn" v-if="!isHistory" @click="submit">目标修订</Button> -->
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <QAComponent ref="qaComponent" @QAData="QAData"></QAComponent>
    <ApprovalRemark ref="ApprovalRemark" @ok="approvalOk"></ApprovalRemark>
  </div>
</template>
<script>
import STIComponent from "./STIComponent";
import axios from "axios";
import QAComponent from "@/components/process/Apply/components/QAComponent";
import ApprovalRemark from "../modalComponents/ApprovalRemark.vue";
import ApprovalHistory from "./ApprovalHistory";
import OperationHistory from "./OperationHistory";
export default {
  components: {
    STIComponent,
    QAComponent,
    ApprovalRemark,
    ApprovalHistory,
    OperationHistory
  },
  data() {
    return {
      value: [2],
      isHistory: false,
      userInfo: {},
      userInfoa: {},
      stiRevokeFlag: "",
      applyId: "",
      applyStatus: "",
      reportId: "",
      userDeptFlag: "",
      applyEditFlag: "",
      spinShow: false,
      qaId: "",
      cardHid: true,
      status: "",
      approvalFlag: 0,
      beApprovalFlag: "",
      panel4value: "审批历史"
    };
  },
  watch: {
    userInfo(newVal, oldVal) {
      this.userInfoa = newVal;
    }
  },
  methods: {
    // 撤销
    cxSti() {
      this.$Modal.confirm({
        title: "请确认是否撤销",
        onOk: () => {
          axios
            .post("/achApply/revokeTarget", {
              id: this.applyId,
              status: this.applyStatus
            })
            .then(res => {
              if (res) {
                this.getData();
                this.$Message.success("撤销成功");
              }
            });
        }
      });
    },
    getData() {
      this.spinShow = true;
      axios
        .post("/achApply/selectApplyDetails", {
          achStage: "STI更新",
          id: this.reportId,
          serialnumber: this.userInfoa.serialnumber,
          year: this.userInfoa.year
        })
        .then(res => {
          this.spinShow = false;
          if (res) {
            this.stiRevokeFlag = res.flagMap.stiRevokeFlag;
            this.applyStatus = res.applyAchInfo.status;
            this.applyId = res.applyAchInfo.id;
            this.$refs.STIComponent.data1 = res.stiTargetInfoList;
            this.$refs.STIComponent.data1.forEach(el => {
              el.single = !!+el.single;
            });
            res.applyAchInfo.empCode ? (this.userInfoa = res.applyAchInfo) : "";
            this.$refs.STIComponent.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.STIComponent.userDeptFlag = res.flagMap.userDeptFlag;
            this.userDeptFlag = res.flagMap.userDeptFlag;
            this.applyEditFlag = res.flagMap.applyEditFlag;
            res.applyAchInfo.empCode
              ? (this.status = res.applyAchInfo.status)
              : "";
            this.beApprovalFlag = res.flagMap.beApprovalFlag;
            this.$refs.STIComponent.specialFlag = res.flagMap.specialFlag;
            this.$refs.STIComponent.beApprovalFlag = res.flagMap.beApprovalFlag;
            this.$refs.STIComponent.specialDisPlayFlag =
              res.flagMap.specialDisPlayFlag;
            this.$refs.STIComponent.getMidData();
            if (res.applyAchInfo.id) {
              this.getApprovalData();
              this.getOperationData();
            }
          }
        });
    },
    submit() {
      this.$refs.STIComponent.data1.forEach(el => {
        el.single ? (el.single = "1") : (el.single = "0");
      });
      console.log(this.$refs.STIComponent.data1);
      let obj = {
        achStage: "STI更新",
        createUser: JSON.parse(sessionStorage.getItem("userInfo")).serialnumber,
        applyAchInfo: {
          ...this.userInfoa,
          // serialnumber:this.userInfo.serialnumber,
          applyUserName: this.userInfoa.userName,
          beReport: "0",
          achTypeUser: this.userInfoa.achTypeUser
        },
        stiTargetInfoList: this.$refs.STIComponent.data1
      };
      this.spinShow = true;
      axios.post("/achApply/saveAchApplyInfo", obj).then(res => {
        this.spinShow = false;
        if (res) {
          this.$Message.success(res);
          this.getData();
        }
      });
    },
    returnApply() {
      this.$router.back();
    },
    QAClick() {
      this.$refs.qaComponent.QAModal = true;
      this.$refs.qaComponent.getUserList();
      this.qaId != "" ? (this.$refs.qaComponent.qaId = this.qaId) : "";
    },
    QAData(val) {
      this.qaId = val;
    },
    approvalSave() {
      this.$refs.ApprovalRemark.modalShow = true;
    },
    approvalOk(value) {
      this.$refs.STIComponent.data1.forEach(el => {
        el.single ? (el.single = "1") : (el.single = "0");
      });
      let obj = {
        ...this.userInfoa,
        idea: value,
        decision: this.approvalFlag,
        beUpdateFlag: "",
        stiTargetInfoList: this.$refs.STIComponent.data1
      };
      this.spinShow = true;
      axios.post("/AchProcess/approvalAchProcess", obj).then(res => {
        this.spinShow = false;
        if (res) {
          this.$Message.info(this.$t("Approval_Completed"));
          this.getData();
        }
      });
    },
    getApprovalData() {
      axios
        .post("/achReport/selectApprovalHistoryList ", {
          achStage: "STI更新",
          id: this.userInfoa.id,
          ...this.$refs.ApprovalHistory.pageInfo
        })
        .then(res => {
          this.$refs.ApprovalHistory.data = res.data;
          this.$refs.ApprovalHistory.total = parseInt(res.pageInfo.total);
        });
    },
    getOperationData() {
      axios
        .post("/achReport/selectOperationHistoryList", {
          achStage: "STI更新",
          id: this.userInfoa.id,
          ...this.$refs.OperationHistory.pageInfo
        })
        .then(res => {
          this.$refs.OperationHistory.data = res.data;
          this.$refs.OperationHistory.total = parseInt(res.pageInfo.total);
        });
    },
    pageChangeApproval(item) {
      this.getApprovalData();
    },
    pageChangeOperation(item) {
      this.getOperationData();
    }
  }
};
</script>

<style lang="less" scoped>
.btnRight {
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  padding-bottom: 15px;
  left: 220px;
  z-index: 99;
  box-shadow: 0px -5px 10px -2px rgba(0, 0, 0, 0.2);
  .btn {
    margin-right: 15px;
    // margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/SITUpdate.vue